import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CustomLink } from 'components/CustomLink';
import routes from 'router/routes';
import { iProspectFile } from 'services/Crm/Crm.type';
import {
  computeScore,
  computeTemperature,
  TEMPERATURE_EMOJI,
} from 'utils/crmScoring';
import s from '../CrmPipeline.module.scss';

interface KanbanCardProps {
  prospect: iProspectFile;
  isOverlay?: boolean;
}

function KanbanCard({ prospect, isOverlay }: KanbanCardProps): JSX.Element {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: prospect.id,
  });

  const temp = computeTemperature(prospect);
  const score = computeScore(prospect, prospect.interactions_count);

  const style: React.CSSProperties = {
    opacity: isDragging ? 0.4 : 1,
    ...(isOverlay === true ? { boxShadow: '0 8px 24px rgba(0,0,0,0.15)' } : {}),
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={s.card}
      style={style}
    >
      <div className={s.cardTop}>
        <CustomLink
          to={routes.crmProspectDetail.to({ prospectId: prospect.id })}
          className={s.cardCompany}
        >
          {prospect.company?.name ?? '-'}
        </CustomLink>
        <span className={s.cardTemp}>{TEMPERATURE_EMOJI[temp]}</span>
      </div>
      {prospect.contact != null && (
        <div className={s.cardContact}>
          {prospect.contact.first_name} {prospect.contact.last_name}
        </div>
      )}
      {prospect.contact?.email != null && (
        <div className={s.cardEmail}>{prospect.contact.email}</div>
      )}
      <div className={s.cardFooter}>
        <div className={s.scoreBarWrap}>
          <div className={s.scoreBar} style={{ width: `${String(score)}%` }} />
        </div>
        <span className={s.scoreLabel}>{score}%</span>
      </div>
    </div>
  );
}

export default KanbanCard;
